module.exports = __webpack_public_path__ + "img/a7defbf.png";